import { render, staticRenderFns } from "./ProcessListPage.vue?vue&type=template&id=33bafff4&scoped=true"
import script from "./ProcessListPage.vue?vue&type=script&lang=js"
export * from "./ProcessListPage.vue?vue&type=script&lang=js"
import style0 from "./ProcessListPage.vue?vue&type=style&index=0&id=33bafff4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bafff4",
  null
  
)

export default component.exports